<template>
  <div id="MainData">
    <vx-card class="shadow-sm" :title="$t('InvestorDetails')">
      
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <h6 class="mb-4 text-primary"><i class="feather icon-user mr-2"></i>{{ $t('BasicInformation') }}</h6>
        </div>
        
        <div class="vx-col md:w-1/4 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t('InvestorCode') }}</label>
          <vs-input v-model="Investor.InvestorCode" class="w-full mt-1" disabled />
        </div>
        
        <div class="vx-col md:w-1/2 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t('FullName') }}</label>
          <vs-input v-model="Investor.UserFullNameAr" class="w-full mt-1" disabled />
        </div>

        <div class="vx-col md:w-1/4 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t('DateOfBirth') }}</label>
          <vs-input type="date" v-model="formattedDate" class="w-full mt-1" />
        </div>
      </div>

      <vs-divider />

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <h6 class="mb-4 text-primary"><i class="feather icon-credit-card mr-2"></i>{{ $t('IdentityDetails') }}</h6>
        </div>

        <div class="vx-col md:w-1/4 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t("Nationality") }}</label>
          <v-select 
            class="mt-1"
            :options="Nationalities" 
            :label="currentLocale === 'ar' ? 'NameAr' : 'NameEn'" 
            v-model="Investor.NationalityId" 
            :reduce="n => n.Id" 
          />
        </div>

        <div class="vx-col md:w-1/4 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t('NationalID_Iqama') }}</label>
          <vs-input v-model="Investor.NationalIdOrIqama" class="w-full mt-1" />
        </div>

        <div class="vx-col md:w-1/4 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t('ID_Type') }}</label>
          <vs-select v-model="Investor.NationalIDType" class="w-full mt-1">
            <vs-select-item :value="1" :text="$t('NationalID')" />
            <vs-select-item :value="2" :text="$t('Iqama')" />
            <vs-select-item :value="3" :text="$t('Passport')" />
          </vs-select>
        </div>
      </div>

      <vs-divider />

      <div class="vx-row">
        <div class="vx-col w-full">
          <h6 class="mb-4 text-primary"><i class="feather icon-trending-up mr-2"></i>{{ $t('InvestmentStatus') }}</h6>
        </div>

        <div class="vx-col md:w-1/3 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t("InvestorCategory") }}</label>
          <v-select 
            class="mt-1"
            :options="InvestorCategories" 
          :label="currentLocale === 'ar' ? 'NameAr' : 'NameEn'" 
            v-model="Investor.InvestorCategoryId" 
            :reduce="c => c.Id" 
          />
        </div>

        <div class="vx-col md:w-1/3 w-full mb-4">
          <label class="text-sm opacity-75">{{ $t("KYCStatus") }}</label>
          <v-select 
            class="mt-1"
            :options="KycStatuses" 
             :label="currentLocale === 'ar' ? 'NameAr' : 'NameEn'"  
            v-model="Investor.InvestorKycStatusId" 
            :reduce="s => s.Id" 
          />
        </div>

        <div class="vx-col md:w-1/3 w-full mb-4 flex items-end pb-2">
          <vs-checkbox v-model="Investor.CanInvest">{{ $t('EligibilityToInvest') }}</vs-checkbox>
        </div>
        <div class="vx-col md:w-1/3 w-full mb-4 flex items-end pb-2">
          <vs-checkbox v-model="Investor.IsCommissionExempt">{{ $t('IsCommissionExempt') }}</vs-checkbox>
        </div>
        
        <div class="vx-col w-full mb-4">
          <label class="text-sm opacity-75">{{ $t('Notes') }}</label>
          <vs-textarea v-model="Investor.Notes" class="w-full mt-1" />
        </div>
      </div>

    </vx-card>

    <div class="flex flex-wrap items-center justify-end mt-6">
      <vs-button type="border" color="rgba(0,0,0,0.5)" icon-pack="feather" icon="icon-x" @click="$router.back()" class="mr-4">
        {{ $t("Cancel") }}
      </vs-button>
      <vs-button icon-pack="feather" icon="icon-save" @click="submitData">
        {{ $t("SaveChanges") }}
      </vs-button>
    </div>
  </div>
</template>

<script>
import VxCard from "../../components/vx-card/VxCard.vue";
import { domain } from "@/gloabelConstant.js";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import moduleInvestors from "@/store/Investors/moduleInvestors.js";
import moduleNationalities from "@/store/Nationality/moduleNationalities.js";
export default {
  components: {
    VxCard,
    Datepicker,
    vSelect
  },
  props: {
    Investor: {
      type: Object,
      required: true,
    }
  },


  data() {
    return {
      baseURL: domain,
      userInfo: {},
      RequiredMessage: "This Field Is Required",

      
    };
  },

  computed: {
    currentLocale() { return this.$i18n.locale; },
    Nationalities() { return this.$store.state.NationalitiesList.Nationalities || []; },
    InvestorCategories() { return this.$store.state.InvestorsList.InvestorCategories || []; },
    KycStatuses() { return this.$store.state.InvestorsList.InvestorKYCStatus || []; },
    

    formattedDate: {
      get() {
        return this.Investor.DateOfBirth ? this.Investor.DateOfBirth.split('T')[0] : "";
      },
      set(val) {
        this.Investor.DateOfBirth = val;
      }
    },



   isFormValid() {
  const basicValidation =
    !this.errors.any() &&
    this.Investor.InvestorCode &&
    this.Investor.UserFullNameAr &&
    this.Investor.DateOfBirth &&
    this.Investor.NationalityId &&
    this.Investor.NationalIdOrIqama &&
    this.Investor.InvestorCategoryId &&
    this.Investor.InvestorKycStatusId;

  return basicValidation;
}
  },

  methods: {
  onCountryChange() {
      this.property.RegionId = null;
      this.property.CityId = null;
      this.property.DistrictId = null;
      
      if (this.property.CountryId != null) {
        this.$vs.loading();
        this.$store.dispatch("RegionList/fetchRegionsByCountry", this.property.CountryId)
          .then(() => { this.$vs.loading.close(); })
          .catch(() => { this.$vs.loading.close(); });
      }
    },


  onRegionChange() {
    this.property.CityId = null;
    this.property.DistrictId = null;
    
    if (this.property.RegionId != null) {
      this.$vs.loading();
      this.$store.dispatch("CityList/fetchCitiesByRegion", this.property.RegionId)
        .then(() => { this.$vs.loading.close(); })
        .catch(() => { this.$vs.loading.close(); });
    }
  },


  onCityChange() {
    this.property.DistrictId = null;
    
    if (this.property.CityId != null) {
      this.$vs.loading();
      this.$store.dispatch("DistrictList/fetchDistrictsByCity", this.property.CityId)
        .then(() => { this.$vs.loading.close(); })
        .catch(() => { this.$vs.loading.close(); });
    }
  },
    initValues() {
      this.Investor = {
        InvestorCode: "",
        UserFullNameAr: "",
        UserFullNameEn: "",
        DateOfBirth: null,
        NationalityId: null,
        NationalIdOrIqama: "",
        NationalIDType: null,
        InvestorCategoryId: null,
        InvestorKycStatusId: null,
        CanInvest: false,
        IsCommissionExempt: false,
        Notes: ""

      };


    },
   submitData() {
  this.$validator.validateAll().then((result) => {
    if (result) {
      const actionName = (this.Investor.Id && this.Investor.Id > 0) 
                         ? "InvestorsList/updateItem" 
                         : "InvestorsList/addItem";

      this.$vs.loading();

      this.$store.dispatch(actionName, this.Investor)
        .then(() => {
    
          this.$vs.loading.close();     
          this.showSuccess();
          return this.$store.dispatch("InvestorsList/fetchDataListItems");
        })
        .then(() => {
          this.cancel(); 
        })
       .catch((err) => {
          this.$vs.loading.close();
          

          let errorMessage = "An error occurred";
          if (err.response && err.response.data && err.response.data.message) {
              errorMessage = err.response.data.message;
          }

          this.$vs.notify({
              time: 2500,
              title: "Error",
              text: errorMessage,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
          });
      });
          }
        });
},

    showSuccess() {
      this.$vs.notify({
        time: 2500,
        title: "Success",
        text: "Saved Successfully",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
      });
    },

    reset_data() {
      this.initValues();
    },
    cancel() {
      this.$router.go(-1);
    },
  

  },
  


  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));

  if (!moduleInvestors.isRegistered) {
      this.$store.registerModule("InvestorsList", moduleInvestors);
      moduleInvestors.isRegistered = true;
    }
     if (!moduleNationalities.isRegistered) {
      this.$store.registerModule("NationalitiesList", moduleNationalities);
      moduleNationalities.isRegistered = true;
    }
   
    

     this.$store.dispatch("InvestorsList/fetchDataListItems");
    this.$store.dispatch("InvestorsList/fetchInvestorCategories");
    this.$store.dispatch("InvestorsList/fetchDataListItems");
    this.$store.dispatch("InvestorsList/fetchInvestorCategories");
    this.$store.dispatch("InvestorsList/fetchInvestorKycStatus");
    this.$store.dispatch("NationalitiesList/fetchDataListItems");


  },

  mounted() {
    this.isMounted = true;
  }
};
</script>


<style lang="scss">

#MainData {
  .vs-input--input, .vs__dropdown-toggle, .vdp-datepicker input {
    border: 1px solid rgba(0, 0, 0, 0.1) !important;
    border-radius: 6px !important; 
    height: 38px !important; 
    padding: 0.6rem !important;
    box-shadow: none !important;
    font-size: 0.9rem;
  }


  label {
    font-weight: 500;
    color: #555;
    margin-bottom: 4px;
    display: block;
    font-size: 0.85rem;
  }


  .vx-row {
    margin-bottom: 0.5rem !important;
  }


  .text-danger {
    font-size: 0.75rem;
    margin-top: 2px;
    display: block;
  }

  .vdp-datepicker__calendar {
    position: absolute;
    z-index: 999999 !important;
    bottom: 100%;
    left: 0;
    background: white;
    box-shadow: 0 5px 25px rgba(0,0,0,0.1);
    border: 1px solid #ddd !important;
    border-radius: 8px;
}


.vx-card {
    overflow: visible !important;
}

.vx-card__collapsible-content {
    overflow: visible !important;
}
}
</style>